export const TAB = "main/TAB";
export const RANGE = "main/RANGE";
